export default "__VITE_ASSET__BhCRNh9w__"